import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 22a6.006 6.006 0 0 0 6-6V8a6 6 0 1 0-12 0v8a6.006 6.006 0 0 0 6 6M12 8a4 4 0 1 1 8 0v8a4 4 0 1 1-8 0zm5 17.95V29a1 1 0 0 1-2 0v-3.05A10.014 10.014 0 0 1 6 16a1 1 0 1 1 2 0 8 8 0 0 0 16 0 1 1 0 0 1 2 0 10.014 10.014 0 0 1-9 9.95"
    />
  </svg>
);
const SvgIconPodcast = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPodcast);
export default Memo;
